var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5268_40739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5833 6.75H13.4167C12.6434 6.75093 11.9021 7.05851 11.3553 7.6053C10.8085 8.15208 10.5009 8.8934 10.5 9.66667H24.5C24.4991 8.8934 24.1915 8.15208 23.6447 7.6053C23.0979 7.05851 22.3566 6.75093 21.5833 6.75Z",
    fill: "#BC6B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.3333C10.5009 15.1065 10.8085 15.8478 11.3553 16.3946C11.9021 16.9414 12.6434 17.249 13.4167 17.2499H21.5833C22.3566 17.249 23.0979 16.9414 23.6447 16.3946C24.1915 15.8478 24.4991 15.1065 24.5 14.3333V10.8333H10.5V14.3333ZM14.5833 14.0416C14.5833 14.2146 14.532 14.3838 14.4359 14.5277C14.3397 14.6716 14.2031 14.7838 14.0432 14.85C13.8833 14.9162 13.7074 14.9335 13.5376 14.8998C13.3679 14.866 13.212 14.7827 13.0896 14.6603C12.9672 14.5379 12.8839 14.382 12.8501 14.2123C12.8164 14.0426 12.8337 13.8666 12.8999 13.7067C12.9662 13.5469 13.0783 13.4102 13.2222 13.314C13.3661 13.2179 13.5353 13.1666 13.7083 13.1666C13.9404 13.1666 14.163 13.2588 14.3271 13.4229C14.4911 13.587 14.5833 13.8095 14.5833 14.0416Z",
    fill: "#BC6B38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5268_40739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(10.5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/Card.8a2e87a597554dae42b2ff8fd8a3e4be.svg";
export { ForwardRef as ReactComponent };